import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IDishAssignmentContext,
	DishAssignmentContext,
} from '../../../../../dishAssignmentState/dishAssignmentContext';
import SelectedItemForBreadcrumbs from 'components/SelectedItem/SelectedItemForBreadcrumbs';
import style from './SubcategoryCrumb.module.scss';

const SubcategoryCrumb: React.FC = () => {
	const { setIDsSelectedSubcategories, subcategories, IDsSelectedSubcategories } =
		useContext<IDishAssignmentContext>(DishAssignmentContext);

	const deleteSubcategory = (subcategoryID: string) => {
		const copyIDsSelectedSubcategories = { ...IDsSelectedSubcategories };
		delete copyIDsSelectedSubcategories[subcategoryID];
		setIDsSelectedSubcategories(copyIDsSelectedSubcategories, true);
	};

	return (
		<div className={style.container} data-test="SubcategoryCrumb">
			<div className={style.scrollWrapper}>
				<Text
					className={style.crumbName}
					translationNameSpace="listing"
					translationKey="subcategoriesLabel"
					size="s"
					weight="bold"
				/>
				{subcategories.map((category, i) => {
					const hasSelectedSubcategories = category.subCategories.find(
						(el) => el.id in IDsSelectedSubcategories,
					);

					return (
						<div key={category.id} data-test={`item-${i}`}>
							{hasSelectedSubcategories && (
								<Text
									className={style.sectionName}
									translationKey={category.name}
									size="xs"
									withTooltip={true}
								/>
							)}
							<div className={style.selectedItemWrapper}>
								{category.subCategories.map((subcategory) => {
									if (subcategory.id in IDsSelectedSubcategories) {
										return (
											<SelectedItemForBreadcrumbs
												key={subcategory.id}
												label={subcategory.name || ''}
												onDelete={() => deleteSubcategory(subcategory.id)}
											/>
										);
									}
								})}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default SubcategoryCrumb;
